import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Image, ScrollView, View, Alert} from 'react-native';
import {BodyText} from 'src/Modules/CommonView';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import {HeaderText} from 'src/Modules/CommonView/Text';
import {ContinueButton} from 'src/Modules/CommonView/Buttons';
import WebView from 'react-native-webview';
import {encode as btoa} from 'base-64';
import {apiSendPostCard} from '../Utils/apiCalls';
import {updateDataAtPath} from '../Utils/fireUtils';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {useUserId} from '../Hooks/reduxHooks';
import {cloudFlareOptimizeImage} from '../Utils/helpers';

const HuntPostCard = () => {
  const {width} = useWindowDimensionsSafe();

  const userId = useUserId();
  const playerChallengePhotos =
    useSelector((state) => state.game?.playerChallengePhotos) || [];
  const treasureChallengePhotos =
    useSelector((state) => state.game?.treasureChallengePhotos) || [];
  const anyTimePhotos = useSelector((state) => state.game?.anyTimePhotos) || [];
  const allChallenges =
    useSelector((state) => state.game_v2?.allChallenges) || [];
  const groupPhoto = useSelector((state) => state.groupInfo?.groupPhoto);
  const city = useSelector((state) => state.groupInfo?.city);
  const teamName = useSelector((state) => state.groupInfo?.teamName);
  const score = useSelector((state) => state.groupInfo?.score);
  const groupId = useSelector((state) => state.groupInfo?.groupId);
  const huntPhoto = useSelector((state) => state.groupInfo?.huntPhoto);
  const rankAtFinish =
    useSelector((state) => state.groupInfo?.rankAtFinish) || 5;
  const huntPostCardFinished = useSelector(
    (state) => state.groupInfo?.huntPostCardFinished,
  );
  const passPlayers = useSelector((state) => state.groupInfo?.passPlayers);

  const [selectedPhotos, setSelectedPhotos] = useState([0, 1, 2]);

  const getPhotos = () => {
    const locationPhotos = Object.values(allChallenges).filter((challenge) => {
      return (
        (challenge.type === 'photo' || challenge.type === 'video') &&
        challenge.photoUrl
      );
    });

    const newPhotosObject = [
      ...playerChallengePhotos,
      ...treasureChallengePhotos,
      ...locationPhotos,
      ...anyTimePhotos,
    ];
    groupPhoto &&
      newPhotosObject.unshift({
        photoUrl: groupPhoto,
        challenge:
          'Have one player take an epic team photo to start your hunt.',
      });
    return newPhotosObject;
  };

  const photoObjects = getPhotos();

  const getSelectedPhotos = () => {
    const selectedPhotosArray = [];
    photoObjects?.map?.((photo, index) => {
      if (selectedPhotos?.includes?.(index)) {
        // console.log({photo});
        selectedPhotosArray.push(photo.downloadURL || photo.photoUrl);
      }
    });
    console.log({selectedPhotosArray});
    return selectedPhotosArray;
  };

  const updateHTML = () => {
    getSelectedPhotos();
  };

  const base64EncodeUnicode = (str) => {
    // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
    // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
    let utf8Bytes = encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/g,
      function (match, p1) {
        return String.fromCharCode('0x' + p1);
      },
    );

    return btoa(utf8Bytes);
  };

  const getPostCardData = () => {
    const selectedUserPhotos = getSelectedPhotos();

    let team_percent = 100 - Math?.round(Math?.min(rankAtFinish, 120) / 2);

    var data = {
      photo_1: selectedUserPhotos?.[0],
      photo_2: selectedUserPhotos?.[1],
      photo_3: selectedUserPhotos?.[2],
      hunt_photo: huntPhoto,
      hunt_city: city,
      team_name: teamName,
      group_id: groupId,
      score: score,
      team_percent,
      user_id: userId,
      is_member: !!passPlayers,
    };

    return data;
  };

  const getPostCardURL = () => {
    let URLData;
    let data = getPostCardData();
    let url;
    const baseUrl =
      __DEV__ && global.localWeb
        ? `https://letsroam.local.com/`
        : //: `https://store.letsroam.com/app/checkout`
          `https://www.letsroam.com/`;
    try {
      console.log({data});
      const stringifiedData = JSON.stringify(data).toString('utf8');
      console.log({stringifiedData});
      URLData = base64EncodeUnicode(stringifiedData);
      url = baseUrl + 'post_hunt_mailer?zoom=1&data=' + URLData;
      console.log({url});
    } catch (e) {
      console.log('error making url', {e});
    }
    return url;
  };

  const sendPostCard = async (address) => {
    const postCardData = getPostCardData();
    const postCardURL = getPostCardURL();
    apiSendPostCard(address, postCardData, postCardURL);
    const path = `scavengerhunt/groups/${
      groupId || 'error'
    }/huntPostCardFinished`;
    console.log({path});
    await updateDataAtPath(path, 1);
    Alert.alert(
      'Post Card Sent',
      'Your post card will arrive within 1 week! Thanks for hunting with us!',
    );
    navigationRef.goBack(null);
  };

  const checkIfDone = () => {
    console.log('checking if huntPostCardFinished ');
    if (!!huntPostCardFinished) {
      console.log('huntPostCardFinished!!');
      console.log('HuntFinished navigate7');
      return navigationRef.navigate('HuntFinished');
    }
  };

  if (!!huntPostCardFinished) {
    console.log('huntPostCardFinished!!');
    console.log('HuntFinished navigate8');
    navigationRef.navigate('HuntFinished');
  }

  const url = getPostCardURL();

  console.log('HuntPostCard render', {url});

  useEffect(() => {
    updateHTML();
    checkIfDone();
  });

  return (
    <View style={{flex: 1, backgroundColor: 'white'}}>
      <ScrollView style={{flex: 1, backgroundColor: 'white'}}>
        <View
          style={{
            flex: 1,
            paddingVertical: 10,
            minHeight: 300,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
          }}>
          {!url && (
            <Image
              style={{width: '100%', height: 220, resizeMode: 'contain'}}
              source={{
                // post card image
                uri: cloudFlareOptimizeImage(
                  'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578277_large.jpg',
                ),
              }}
            />
          )}
          {!!url && (
            <WebView
              style={{
                flex: 1,
                height: 270,
                width,
                resizeMode: 'cover',
              }}
              injectedJavaScript={`
                  mainCard = document.querySelector('#mainCard');
                  mainCard.style.zoom = window.innerWidth / (96 * 6)
                `}
              scalesPageToFit={false}
              bounces={false}
              source={{uri: url}}
            />
          )}
          <HeaderText
            text={'Get A Free Postcard'}
            textStyle={{marginLeft: 5, textAlign: 'center'}}
            bodyStyle={{marginLeft: 10, width: '90%'}}
          />
          <BodyText
            text={`Remember your hunt with a free post card! Thank you so much for doing a scavenger hunt with us! As a special thank you from Let's Roam, we want to send you a special postcard. Limit 1 per group!`}
          />

          <View>
            <ContinueButton
              containerStyle={{
                width: width - 60,
                marginTop: 10,
                marginHorizontal: 30,
              }}
              text={`Send Us A Post Card!`}
              handlePress={() =>
                navigationRef.navigate('HuntPostCardAddressConfirm', {
                  handleConfirm: (address) => {
                    sendPostCard(address, url);
                  },
                })
              }
            />
            <ContinueButton
              containerStyle={{
                width: width - 60,
                marginTop: 10,
                marginHorizontal: 30,
                backgroundColor: global?.color?.teal,
              }}
              text={`Change Photos`}
              handlePress={() =>
                navigationRef.navigate('PhotosModal', {
                  photoData: photoObjects,
                  title: 'Pick Up to 3 Card Photos',
                  selectable: true,
                  maxSelectable: 3,
                  initialSelection: selectedPhotos,
                  handleSelectionDone: (newSelection) => {
                    setSelectedPhotos(newSelection);
                  },
                })
              }
            />
            <ContinueButton
              handlePress={async () => {
                const path = `scavengerhunt/groups/${
                  groupId || 'error'
                }/huntPostCardFinished`;
                console.log({path});
                await updateDataAtPath(path, 1);
                navigationRef.goBack(null);
              }}
              containerStyle={{
                width: width - 60,
                marginTop: 10,
                marginHorizontal: 30,
                backgroundColor: global?.color?.gray3,
              }}
              text={`Skip & See Your Score`}
            />
          </View>

          <View></View>
        </View>
      </ScrollView>
    </View>
  );
};

export default HuntPostCard;
